/* Shoppable videos — IntersectionObserver autoplay (muted), tap for sound, quick-add hook */
class MVShoppableVideos extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.autoplay = this.dataset.autoplay !== "false";
    this.startMuted = this.dataset.startMuted !== "false";
    this.reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    this.videos = [...this.querySelectorAll("video")];
    this.videos.forEach((v) => { v.muted = this.startMuted; v.playsInline = true; v.loop = true; v.controls = false; });

    // Play muted videos only while they're in view; pause off-screen to save data/battery.
    if (this.autoplay && !this.reduced && "IntersectionObserver" in window) {
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          const v = e.target;
          if (e.isIntersecting && e.intersectionRatio >= 0.5) v.play?.().catch(() => {});
          else v.pause?.();
        });
      }, { threshold: [0, 0.5, 1] });
      this.videos.forEach((v) => this.io.observe(v));
    }

    this.onClick = (e) => {
      // Quick-add → open the size sheet (reuses the theme's quick-add), never navigate
      const qa = e.target.closest("[data-sv-quickadd]");
      if (qa) { e.preventDefault(); window.MV && MV.emit("quickadd:open", { handle: qa.dataset.handle, source: qa }); return; }
      // Product link → let it navigate to the PDP
      if (e.target.closest("[data-sv-product]")) return;
      // Anywhere else on the card (video or the sound button) → toggle sound / play
      const card = e.target.closest("[data-sv-card]");
      if (card) this.toggleSound(card);
    };
    this.addEventListener("click", this.onClick);
  }

  toggleSound(card) {
    const v = card.querySelector("video");
    if (!v) return;
    if (v.paused) { v.muted = false; v.play?.().catch(() => {}); }
    else { v.muted = !v.muted; }
    card.classList.toggle("is-muted", v.muted);
  }

  disconnectedCallback() {
    this.io?.disconnect();
    this.removeEventListener("click", this.onClick);
    this.bound = false;
  }
}
customElements.define("mv-shoppable-videos", MVShoppableVideos);
